var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBat = function SvgBat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.631 6.98a.253.253 0 0 0-.395.109c-.455 1.265-1.154 2.461-3.629 3.208a3.7 3.7 0 0 0 .143-.971 3.75 3.75 0 1 0-7.5 0 3.7 3.7 0 0 0 .143.971C5.918 9.55 5.219 8.354 4.764 7.089a.253.253 0 0 0-.4-.109C.738 9.945.748 13.387.75 17.993a.244.244 0 0 0 .456.118c2.785-4.752 6.108-2.687 6.8-.478a.25.25 0 0 0 .35.149 2.846 2.846 0 0 1 3.42 1.567.246.246 0 0 0 .454 0 2.846 2.846 0 0 1 3.42-1.567.25.25 0 0 0 .35-.149c.689-2.209 4.012-4.274 6.8.478a.244.244 0 0 0 .456-.118c-.004-4.606.006-8.048-3.625-11.013"
  })));
};
export default SvgBat;